//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.section`
    display: flex;
    flex-direction: column;
    align-self: center;
    justify-content: flex-start;
    align-items: center;
    gap: 30px;
    width: 65%;
    margin-bottom: 30px;
`;
export const Content = styled.ul`
    display: grid;
    gap: 20px;
    width: 100%;
    margin: 0;
    padding: 0;
    place-items: center;
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
`;
export const CampusCard = styled.li`
    display: flex;
    text-decoration: none;
    padding: 20px;
    display: flex;
    flex-direction: column;
    margin: 0;
    gap: 10px;
    border-radius: 8px;
    min-width: 260px;
    width: 100%;
    max-width: 280px;
    height: 90px;
    background-color: var(--light-1);
    cursor: pointer;
    &, 
    & .text, 
    & .icon path {
        transition: 0.35s;
    }
    & .text {
        font-size: 14px;
        font-weight: bold;
        color: var(--purple-6);
        margin: 0;
        user-select: none;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        max-width: 80%;
    }
    & .icon path {
        fill: var(--purple-2);
    }
    & .button {
        &, & path {
            transition: 0.35s;
        }
        &:hover {
            transform: rotate(15deg);
        }
    }
    &:hover {
        background-color: var(--purple-2);
        & .text { color: var(--light-1); }
        & .icon path, 
        & .button path { fill: var(--light-1); }
    }
    &.disabled {
        background-color: var(--light-blue-1);
        & .text { color: var(--light-gray-4); }
        & .icon path, 
        & .button path { fill: var(--light-gray-4); }
        &:hover {
            & .text {
                color: var(--purple-4);
            }
            & .icon path, 
            & .button path { fill: var(--purple-2); }
        }
    }
`;